// ─────────────────────────────────────────────────────────────────────────────
// RouteTracker.js
//
// Invisible component that listens for React Router v6 location changes and
// fires a GA4 page_view event on every navigation — including the first load.
//
// Requirements:
//   • Must be rendered INSIDE <BrowserRouter> so useLocation() works.
//   • Renders nothing to the DOM (returns null).
// ─────────────────────────────────────────────────────────────────────────────

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../services/analytics';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Combine pathname + search so query-string changes are also tracked
    // e.g. /shop?category=clocks counts as a separate page view
    trackPageView(location.pathname + location.search);
  }, [location]); // Re-run whenever the user navigates

  // This component is a side-effect only — it renders nothing
  return null;
};

export default RouteTracker;
